import { PathsEnum } from 'pages/Paths'
import { Navigate, Route, Routes } from 'react-router-dom'
import AccountSettingsOrg from './AccountSettingsOrg'
import { AccountSettingsRouter } from './AccountSettingsRouter'

export const AccountRouter = ({ loggedIn }: { loggedIn: boolean }) => {
  return (
    <Routes>
      <Route path={PathsEnum.accountSettingsOrg} element={<AccountSettingsOrg />} />

      <Route
        path={`${PathsEnum.accountSettings}/${PathsEnum.other}`}
        element={loggedIn ? <AccountSettingsRouter /> : <Navigate to={PathsEnum.login} />}
      />

      <Route path={PathsEnum.other} element={<Navigate to={PathsEnum.root} />} />
    </Routes>
  )
}
